import React from 'react'
import { useParams } from 'react-router-dom'

import { RechargesHistory } from '~/balance/components'
import { getNonFixedSubscriptionFromProductId } from '~/customer/helpers/customer.helpers'
import useCustomer from '~/customer/useCustomer'
import { CustomCircularProgress } from '~/ui/components'

interface ParamsProps {
  customerIdentifier: string
  productId: string
}

const RechargesHistoryContainer: React.FC = () => {
  const { customer } = useCustomer()
  const { customerIdentifier, productId }: ParamsProps = useParams()

  const currentSubscription = customer && getNonFixedSubscriptionFromProductId(customer, productId)

  return currentSubscription && productId ? (
    <RechargesHistory
      customerIdentifier={customerIdentifier}
      productId={productId}
      subscriptionId={currentSubscription.id}
    />
  ) : (
    <CustomCircularProgress />
  )
}

export default RechargesHistoryContainer
